const ORDERED_LIST_LINE_PATTERN = /^\s*\d+\.\s+/;

function isOrderedListLine(line) {
  return ORDERED_LIST_LINE_PATTERN.test(line);
}

function orderedListNumber(line) {
  const matched = String(line || '').match(/^\s*(\d+)\.\s+/);
  return matched ? Number(matched[1]) : null;
}

function isSectionBoundaryLine(line) {
  const text = String(line || '').trim();
  if (!text) {
    return false;
  }
  if (/^#{1,6}\s+\S/.test(text)) {
    return true;
  }
  if (/^([-*_])(?:\s*\1){2,}$/.test(text)) {
    return true;
  }
  return /^[一二三四五六七八九十百千万]+[、.．]\s*\S/.test(text);
}

function normalizeOrderedListSegment(lines, startIndex, endIndex, resetToOne) {
  const orderedListLineIndexes = [];
  for (let index = startIndex; index < endIndex; index += 1) {
    if (isOrderedListLine(lines[index])) {
      orderedListLineIndexes.push(index);
    }
  }
  if (orderedListLineIndexes.length === 0) {
    return;
  }

  const currentNumbers = orderedListLineIndexes.map((index) => orderedListNumber(lines[index]));
  const alreadyStrictlyIncremental = currentNumbers.every((value, index, arr) => (
    value !== null && (index === 0 || value === arr[index - 1] + 1)
  ));
  if (!resetToOne && alreadyStrictlyIncremental) {
    return;
  }

  let nextNumber = 1;
  orderedListLineIndexes.forEach((index) => {
    const line = lines[index];
    const leading = line.match(/^\s*/)?.[0] || '';
    const contentText = line.replace(ORDERED_LIST_LINE_PATTERN, '');
    lines[index] = `${leading}${nextNumber}. ${contentText}`;
    nextNumber += 1;
  });
}

export function normalizeOrderedListNumbers(content) {
  const lines = String(content ?? '').replace(/\r\n/g, '\n').split('\n');
  let segmentStartIndex = 0;
  let resetSegmentToOne = false;

  lines.forEach((line, index) => {
    if (!isSectionBoundaryLine(line)) {
      return;
    }
    normalizeOrderedListSegment(lines, segmentStartIndex, index, resetSegmentToOne);
    segmentStartIndex = index + 1;
    resetSegmentToOne = true;
  });
  normalizeOrderedListSegment(lines, segmentStartIndex, lines.length, resetSegmentToOne);

  return lines.join('\n');
}

export function consumeOrderedListBlock(lines, startIndex) {
  const items = [];
  let index = startIndex;
  let firstNumber = 1;

  while (index < lines.length && /^\d+\.\s+/.test(lines[index])) {
    const matched = lines[index].match(/^(\d+)\.\s+([\s\S]*)$/);
    if (matched) {
      firstNumber = items.length === 0 ? Number(matched[1]) : firstNumber;
      items.push(matched[2]);
    } else {
      items.push(lines[index].replace(/^\d+\.\s+/, ''));
    }
    index += 1;
  }

  return {
    firstNumber: Number.isFinite(firstNumber) && firstNumber > 0 ? firstNumber : 1,
    items,
    nextIndex: index,
  };
}
